//noScroll
class Information {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const $js_tab = $('.js-tab-title');
    const $js_tab_target = $('.js-tab-img');
    const cls = 'active';

    $js_tab.on('click', function () {
      const this_category = $(this).data('title');
      $js_tab_target.removeClass(cls);
          
      $js_tab_target.each(function () {
        const target_data = $(this).data('img');
        if (this_category === target_data) {
          $(this).addClass(cls);
        }
      });
    
    });
  }
}
